import React, { useMemo } from 'react';
import styles from './EditAccountCurrencyModal.module.scss';
import { ReactComponent as SetProcessingCurrency } from './assets/set-processing-currency.svg';
import { ReactComponent as ExchangeRateInfo } from './assets/exchange-rate-info.svg';
import { ViewTypes } from 'shared/components/CurrencySelect/processingCurrencyViewType.enum';
import { CurrencySelect } from '../../../../../shared/components/CurrencySelect/CurrencySelect';
import { Currency } from 'shared/components/CurrencySelect/types';

interface CurrencySelectionStepProps {
  newProcessingCurrency: Currency | null;
  setNewProcessingCurrency: (currency: Currency) => void;
  viewType: ViewTypes;
  currenciesArray: Currency[];
  processingCurrency: Currency;
}

export const CurrencySelectionStep: React.FC<CurrencySelectionStepProps> = ({
  newProcessingCurrency,
  setNewProcessingCurrency,
  viewType,
  currenciesArray,
  processingCurrency,
}) => {
  const selectedCurrency = useMemo(() => {
    return newProcessingCurrency ?? processingCurrency ?? 'USD';
  }, [newProcessingCurrency, processingCurrency]);
  return (
    <div className={styles.currencySelection}>
      <div className={styles.currencyContainer}>
        <div className={styles.currencyLeft}>
          <p>
            <b>Currency</b>
          </p>
          <CurrencySelect
            selectedCurrency={selectedCurrency?.code}
            currenciesArray={currenciesArray}
            setSelectedCurrency={(currencyCode: string) => {
              const selected = currenciesArray.find((currency) => currency.code === currencyCode);
              setNewProcessingCurrency(selected!);
            }}
          />
          <div className={styles.info}>
            <ExchangeRateInfo className={styles.infoIcon} />
            <div className={styles.infoText}>
              <b>The exchange rate</b> is fixed for the entire month and is
              {viewType === ViewTypes.AzureExchangeRate
                ? ' set based on the rate from two business days before the end of the previous month (Azure exchange rate concept).'
                : ' determined based on the last business day of the previous month.'}
            </div>
          </div>
        </div>
        <div className={styles.currencyRight}>
          <SetProcessingCurrency />
        </div>
      </div>
    </div>
  );
};
